import React from 'react';
import { CardMedia, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function PanIndiaRoadSectionMobile() {
  const navigate = useNavigate();

  return (
    <>
      <Stack px={2} pb={4}>
        <CardMedia component="img" src="/assets/images/HomeMobile/mw.webp" alt="Car History" />
      </Stack>
      <Stack>
        <CardMedia component="img" src="/assets/images/HomeMobile/panIndiaMobile.webp" alt="Car History" />
      </Stack>
      <Stack px={2} id="Inspect" onClick={() => navigate('/inspection')} sx={{ cursor: 'pointer' }}>
        <CardMedia component="img" src="/assets/images/HomeMobile/InspectHomeMobile.webp" alt="Car History" />
      </Stack>
      {/* <Box
        component="img"
        src="/assets/images/HomeMobile/panIndia.webp"
        alt="Warranty Image"
        sx={{
          width: '100%',
          //   height: 120,
          objectFit: 'cover',
          display: 'block',
          borderRadius: '0px ',
        }}
      />

      <Stack
        spacing={2}
        mx={2}
        sx={{
          bgcolor: '#121212',
          pt: 3,
          pb: 4,
          px: 5,
          textAlign: 'center',
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: '14px',
            color: '#FFFFFFDE',
            lineHeight: 1.4,
          }}
        >
          With our Pan India Roadside Assistance, help is always just a call away—no matter where you are. Whether it’s
          a flat tire, dead battery, towing, or emergency fuel, our reliable support network covers you across the
          country, ensuring you're never stranded.
        </Typography>
      </Stack>
      <Box
        id="Inspect"
        component="img"
        src="/assets/images/HomeMobile/InspectionVehicle.webp"
        alt="Warranty Image"
        sx={{
          width: '100%',
          //   height: 120,
          objectFit: 'cover',
          display: 'block',
          borderRadius: '0px ',
        }}
      />
      <Stack
        spacing={2}
        mx={1}
        sx={{
          bgcolor: '#121212',
          px: 8,
          pt: 4,
          pb: 3,
          textAlign: 'center',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            fontSize: '24px',
            zIndex: 2,
            background: 'linear-gradient(to right, #EA5D16, #F6851F)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
            lineHeight: 1.2,
          }}
        >
          Inspect any Car With <br />
          Focus Warranty
        </Typography>

        <Typography
          variant="caption"
          sx={{
            fontSize: '14px',
            color: '#FFFFFFDE',
            lineHeight: 1.4,
          }}
        >
          Before you buy, inspect your car thoroughly and get it backed by Focus Warranty. Our expert inspection ensures
          key systems are checked for reliability, and the included warranty protects you from unexpected repairs
        </Typography>
      </Stack>
      <Stack mx={2}>
        <Button
          sx={{
            width: '100%',
            backgroundColor: '#93642C',
            color: '#e0e0e0',
            fontSize: '16px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            fontWeight: 600,
            justifyContent: 'center', // center text & icon
            gap: 1,
            paddingY: '10px', // reduce top & bottom padding
            lineHeight: 1.2, // keep text snug vertically
            minHeight: 'unset',
            textTransform: 'unset',
            transition: 'background-color 0.3s ease',
            '&:hover': {
              backgroundColor: '#7a5023',
            },
          }}
        >
          Book an Inspection Service
        </Button>
      </Stack> */}
    </>
  );
}
